import { AppState } from '@/vuex/store';
import { Account } from '@/common/models/Account';

export default {
  // UPDATE_ACCOUNT: (state: AppState, account: Account) => {
  //   state.accountState.changeAccountNum = state.accountState.changeAccountNum + 1;
  //   if (account != null) {
  //     state.accountState.hasLoginAcount = true;
  //   }
  //   state.accountState.hasLogin = true;
  //   state.accountState.account = account;
  // },
};

